const _ = require('lodash')

exports.TYPES = {
  ARTICLE: 'article',
  INTEREST: 'interest',
  MIX: 'mix',
  USER: 'user'
}

exports.TYPES_KEYS = _.invert(exports.TYPES)

exports.ARTICLE_SUBTYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  IMAGE: 'images',
  TEXT: 'text',
  TEXT_WITH_IMAGE: 'text_with_image'
}

exports.ARTICLE_SUBTYPES_KEYS = _.invert(exports.ARTICLE_SUBTYPES)
